import { Animated } from 'react-native'

import { usePulse } from '../hooks/usePulse'
import { useTheme } from '../theme/restyle'

export interface SkeletonBarProps {
  /** Sized to the text it stands in for, so nothing moves when the value lands. */
  width: number
  height: number
  /** The design rounds a text-height bar at 4, and a display-sized one further. */
  borderRadius?: number
}

/** A value that hasn't arrived yet. */
export function SkeletonBar({
  width,
  height,
  borderRadius = 4,
}: SkeletonBarProps) {
  const theme = useTheme()
  const opacity = usePulse()
  return (
    <Animated.View
      accessibilityRole="progressbar"
      style={{
        width,
        height,
        borderRadius,
        opacity,
        backgroundColor: theme.background.pill.pressed,
      }}
    />
  )
}
